import React, { useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Row, Col, Card, CardBody,
  NavLink
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";

const ProductBulkImportModal = ({ open, toggle, onSuccess }) => {

  const dispatch = useDispatch();
  const loading = useSelector(state => state.loading.loading);

  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);

  /* ================= UPLOAD ================= */
  const upload = async () => {

    if (!file) return toast.error("Please select CSV file");

    const formData = new FormData();
    formData.append("file", file);

    dispatch(loadingTrue());

    try {
      const res = await Handler({
        method: "post", url: "/products/import_csv.php", data: formData, headers: { "Content-Type": "multipart/form-data" }
      });

      if (res?.success) {
        toast.success("CSV import completed");
        toast.warning(res?.data?.failed || "Duplicates found")
        setResult(res.data);
        onSuccess && onSuccess();
        reloadWindowToPath('/products')
      } else {
        toast.error(res?.message || "Import failed");
      }

    } catch {
      toast.error("Network error");
    }

    dispatch(loadingFalse());
  };

  /* ================= RESET ================= */
  const closeModal = () => {
    setFile(null);
    setResult(null);
    toggle();
  };

  return (
    <Modal isOpen={open} toggle={closeModal} size="lg" centered>
      <ModalHeader toggle={closeModal}>
        Product Bulk Import (CSV)
      </ModalHeader>

      <ModalBody>
        <div className="mb-3 text-muted small text-center d-flex justify-content-between">
          <div className="mb-3">
            <h6 className="fw-semibold mb-2">Product Details</h6>
            <ul className="list-unstyled ps-2 text-start">
              <li><span className="text-danger">●</span> Product Name</li>
              <li><span className="text-danger">●</span> Selling Price</li>
              <li><span className="text-danger">●</span> Purchase Price</li>
              <li><span className="text-danger">●</span> GST %</li>
              <li><span className="text-danger">●</span> Unit</li>
              <li><span className="text-danger">●</span> Quantity</li>
              <li><span className="text-danger">●</span> Category</li>
              <li><span className="text-danger">●</span> Sub Category</li>
            </ul>
          </div>

          {/* Variant Section */}
          <div>
            <h6 className="fw-semibold mb-2">Variant Details (if Needed)</h6>
            <ul className="list-unstyled ps-2  text-start">
              <li><span className="text-danger">●</span> Variant Name</li>
              <li><span className="text-danger">●</span> Selling Price</li>
              <li><span className="text-danger">●</span> Purchase Price</li>
              <li><span className="text-danger">●</span> GST %</li>
            </ul>
          </div>
          <i className="red">Don't Change the Outlet Id in CSV</i>
        </div>
        <div className="d-flex justify-content-center">
          <NavLink
            to="#"
            onClick={(e) => { e.preventDefault(); const link = document.createElement("a"); link.href = "/product-import.csv"; link.download = "product-import.csv"; document.body.appendChild(link); link.click(); document.body.removeChild(link); }} className="menu-item mb-4 sample-btn"
          >
            <i className="bx bx-download me-2"></i> Download Sample CSV
          </NavLink>
        </div>

        {/* FILE PICK */}
        <Row className="mb-3">
          <Col md={12}>
            <Input
              type="file"
              accept=".csv"
              onChange={e => setFile(e.target.files[0])}
            />
            <small className="text-muted">
              Upload CSV file only (.csv)
            </small>
          </Col>
        </Row>

        {/* RESULT SUMMARY */}
        {result && (
          <Row className="g-3 mb-3">

            <Col md={3}>
              <Card className="border-success">
                <CardBody>
                  <div className="fw-bold text-success">Products</div>
                  <h5>{result.products_created}</h5>
                </CardBody>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-info">
                <CardBody>
                  <div className="fw-bold text-info">Variants</div>
                  <h5>{result.variants_created}</h5>
                </CardBody>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-warning">
                <CardBody>
                  <div className="fw-bold text-warning">Skipped</div>
                  <h5>{result.skipped}</h5>
                </CardBody>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-danger">
                <CardBody>
                  <div className="fw-bold text-danger">Failed</div>
                  <h5>{result.failed}</h5>
                </CardBody>
              </Card>
            </Col>

          </Row>
        )}

        {/* ERROR LIST */}
        {result?.errors?.length > 0 && (
          <div className="mt-3">
            <h6 className="fw-bold text-danger">Errors</h6>
            <ul className="small text-danger">
              {result.errors.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          </div>
        )}

      </ModalBody>

      <ModalFooter>
        <Button disabled={loading} color="light" onClick={closeModal}>Close</Button>
        <Button disabled={loading} className="add-btn" onClick={upload}>Upload CSV</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProductBulkImportModal;
